module.exports = __webpack_public_path__ + "185ccf8be7b361cae3a98a4099d2248a.png";